export default {
    "Common.Dashboard":
    {
        permissionGroupId: "Dashboard",
        sortOrder: 10,
        caption: '首页',
        path: '/dashboard',
        icon: 'fx-font fx-gongzuotai',
    }
};



// WEBPACK FOOTER //
// ./src/modules/common/menu.js